import * as React from 'react';
import { emptyFn } from '../../utilities';
import { rem } from 'polished';
import InputSmarttag from '../InputSmarttag';
import SmarttagTags from '../SmarttagTags';
import styled from 'styled-components';
const Wrapper = styled.div ``;
const SmarttagTagsWrapper = styled('div') `
  margin-top: ${rem(10)};
`;
const SmarttagControl = ({ readOnly = false, creatable = true, disabled = false, value = [], onChange = emptyFn, availableSmarttags = [], getSmarttagsKeys = null, getSmarttagsValues = null, getSmarttagsByFts = null, ...restProps }) => {
    return (React.createElement(Wrapper, null,
        !readOnly && (React.createElement(InputSmarttag, { creatable: creatable, disabled: disabled, onAdd: newSmarttag => {
                let smarttags = value ? [...value] : [];
                const smarttagIndex = smarttags.findIndex(stag => stag.key === newSmarttag.key);
                if (smarttagIndex === -1) {
                    smarttags.push(newSmarttag);
                }
                else {
                    const smarttag = { ...smarttags[smarttagIndex] };
                    const idx = smarttag.values.findIndex((val) => val.key === newSmarttag.values[0].key);
                    if (idx === -1) {
                        smarttag.values = [...smarttag.values, newSmarttag.values[0]];
                    }
                    smarttags = [
                        ...smarttags.slice(0, smarttagIndex),
                        smarttag,
                        ...smarttags.slice(smarttagIndex + 1),
                    ];
                }
                onChange([...smarttags]);
            }, availableSmarttags: availableSmarttags, getSmarttagsKeys: getSmarttagsKeys, getSmarttagsValues: getSmarttagsValues, getSmarttagsByFts: getSmarttagsByFts, readOnly: readOnly, ...restProps })),
        React.createElement(SmarttagTagsWrapper, null,
            React.createElement(SmarttagTags, { ...(!readOnly && {
                    onChange: newSmarttags => {
                        onChange(newSmarttags);
                    },
                }), items: value || [], disabled: disabled }))));
};
export default SmarttagControl;
